
import RequestService from '../request-service';

/**
 * Api request service for rest/FEWBetSlip/CheckCashout
 */
export default class CheckCashoutService extends RequestService {
  constructor(betId = 0) {
    super();

    this.endpoint = this.$config.endpoints.checkCashout;
    this.method = 'get';

    const { authorizationHeaders } = this.$config;
    this.headers = {
      ExternalUserID: APP_SETTINGS.player.id,
      ...authorizationHeaders
    };

    this.getParams = {
      betSlipGroupID: betId
    };
  }
}
